import styled from "@emotion/styled";
import { TypeRampV2 } from "../../typography";
import { formLabelColorTheme } from "./formLabelColorTheme";
export const FormLabelValidation = styled(TypeRampV2)`
    font-weight: 400;
    margin-top: 1px;
    color: ${_ref => {
  let {
    themeMode,
    validationState
  } = _ref;
  return formLabelColorTheme.color[validationState](themeMode);
}};
`;
//# sourceMappingURL=FormLabelValidation.js.map